import { Button } from '@/components/ui/button'
import { Dialog, DialogContent } from '@/components/ui/dialog'
import { isInIframe, openInNewTab } from '@/lib/utils'
import { AlertCircle } from 'lucide-react'
import { memo, useEffect } from 'react'

const DEBOUNCE_KEY = 'opened-in-new-tab-ts'
const DEBOUNCE_MS = 5000

export const OpenInNewTab = memo(function OpenInNewTab() {
  // Try to automatically open in new tab, debounced to prevent duplicates from SW-triggered reloads
  useEffect(() => {
    if (!isInIframe) return
    const last = Number(sessionStorage.getItem(DEBOUNCE_KEY) || 0)
    if (Date.now() - last > DEBOUNCE_MS) {
      sessionStorage.setItem(DEBOUNCE_KEY, String(Date.now()))
      openInNewTab(window.location.href)
    }
  }, [])

  if (!isInIframe) {
    return null
  }

  return (
    <Dialog open={isInIframe}>
      <DialogContent className="sm:max-w-lg">
        <div className="flex flex-col items-center justify-center space-y-6 p-4">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-secondary">
            <AlertCircle className="h-6! w-6! text-foreground" />
          </div>

          <div className="text-center">
            <div className="mb-2 text-xl font-semibold tracking-tight">Open in new tab</div>
            <p className="mb-6 text-sm text-muted-foreground">
              The best way to use the Daisy proposal tool is to open the application in a new tab.
            </p>
            {/* <p className="mb-6 text-sm text-muted-foreground">
              We've attempted to open this page in a new tab. If it didn't open automatically, please click the button
              below.
            </p> */}

            <Button onClick={() => openInNewTab(window.location.href)} className="inline-flex items-center gap-2">
              Open in new tab
            </Button>
          </div>

          {/* <div className="text-center">
            <p className="text-xs text-muted-foreground">
              The best way to use the Daisy proposal tool is to open the application in a new tab.
            </p>
          </div> */}
        </div>
      </DialogContent>
    </Dialog>
  )
})
